import Vue from "vue";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "./style.scss";
import { APP_LOGGER } from "@/app/logger";

APP_LOGGER.debug("Install vue2-perfect-scrollbar", { PerfectScrollbar });
Vue.use(PerfectScrollbar);
